module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cooking-book-7034c853c91d6b8c0985c4d02328098c.svg";